'use client'

import { isAxiosError } from 'axios'
import { useEffect } from 'react'
import { useSessionStorage } from 'usehooks-ts'

import { HTTP_STATUS_CODE_UNAUTHORIZED } from '../http'

import { useUserApiSwrSessionV1Customer } from './api/swr/useUserApiSwrSessionV1Customer'

const WAS_LOGGED_IN_KEY = 'userWasLoggedInOnPreviousSessionCall'

export const useGtmPushLogoutOnSessionEnd = ({
  onLogout,
}: {
  onLogout: () => void
}): void => {
  const [wasUserLoggedIn, setWasUserLoggedIn, clearWasUserLoggedIn] =
    useSessionStorage(WAS_LOGGED_IN_KEY, false, {
      initializeWithValue: false,
    })
  const sessionDataSwr = useUserApiSwrSessionV1Customer()
  const isUnauthorizedSessionResponse =
    isAxiosError(sessionDataSwr.error) &&
    sessionDataSwr.error.response?.status === HTTP_STATUS_CODE_UNAUTHORIZED
  const isSessionCallDone =
    Boolean(sessionDataSwr.data) || isUnauthorizedSessionResponse

  useEffect(() => {
    if (!isSessionCallDone) {
      return
    }

    if (sessionDataSwr.data?.customerNumber) {
      setWasUserLoggedIn(true)

      return
    }

    if (!wasUserLoggedIn) {
      return
    }

    onLogout()
    clearWasUserLoggedIn()
  }, [
    clearWasUserLoggedIn,
    isSessionCallDone,
    onLogout,
    sessionDataSwr.data?.customerNumber,
    setWasUserLoggedIn,
    wasUserLoggedIn,
  ])
}
